import { call, put, takeLatest } from "redux-saga/effects";
import { axiosRestInstance } from "../../../common/axios";
import { AxiosResponse } from "axios";
import { LogType } from "../../slices/global-logs/Types";
import { globalLogsSliceAction } from "../../slices/global-logs";
import {
  getGlobalLogsSagaAction,
  globalLogsSagaActionTypes,
} from "./saga-actions";

type getGlobalLogsAPIResponseType = {
  success: boolean;
  message: string;
  data: LogType[];
};

const getGlobalLogsAPI = async (logType: string) => {
  const response = await axiosRestInstance
    .get<AxiosResponse<getGlobalLogsAPIResponseType>>(`/logs/logsData/${logType}`)
    .then((res) => res.data);
  return response;
};

function* getGlobalLogsSaga(action: { type: string; logType: string }) {
  try {
    yield put(globalLogsSliceAction.setGlobalLogsLoading(true));
    const response: getGlobalLogsAPIResponseType = yield call(
      getGlobalLogsAPI,
      action.logType
    );
    yield put(globalLogsSliceAction.setGlobalLogs(response.data?.reverse() || []));
  } catch (e) {
    yield put(globalLogsSliceAction.setGlobalLogs([]));
    console.log(e);
  } finally {
    yield put(globalLogsSliceAction.setGlobalLogsLoading(false));
  }
}

function* globalLogsSaga() {
  yield takeLatest(
    globalLogsSagaActionTypes.callGetGlobalLogsSaga,
    getGlobalLogsSaga
  );
}

export default globalLogsSaga;
